import { useState, useEffect } from 'react';
import * as C from './styles';
import { BsExclamationTriangleFill } from "react-icons/bs";
import { Link } from 'react-router-dom';

const Seasons = ({ movie }) => {

    const [showFullMessage, setShowFullMessage] = useState(false);

    const toggleMessage = () => {
        setShowFullMessage(!showFullMessage);
    };

    useEffect(() => {
        document.body.scrollTo(0, 0);
        console.log(movie.seasons);
    }, [movie]);

    return (
        <C.Container id='container-pop-up-season'>
            <C.Message>
                <h4><BsExclamationTriangleFill /> Atenção!</h4>
                <span>As temporadas exibidas nesta seção não indicam que estão disponíveis para assistir no MOOV.</span>
            </C.Message>
            <C.Main id="pop-up-season">
                {movie?.seasons?.slice().reverse().map((season, key) => {
                    if (season.season_number >= 0 && season.air_date) {
                        return (
                            <Link to={`?detalhes=temporadas&temporada=${season.season_number}`} className='season' key={key}>
                                <img src={season?.poster_path ? `https://image.tmdb.org/t/p/w400${season?.poster_path}` : "https://www.themoviedb.org/assets/2/v4/glyphicons/basic/glyphicons-basic-38-picture-grey-c2ebdbb057f2a7614185931650f8cee23fa137b93812ccb132b9df511df1cfac.svg"} loading='lazy' alt={`Poster da ${season?.season_number} temporada da série ${season.name}`} />
                                <header>
                                    <span>{season?.season_number > 0 ? `Temporada ${season?.season_number}` : "Especiais"}</span>
                                </header>
                                <main>
                                    {season?.episode_count && <span>{season?.episode_count} Episódios</span>}
                                </main>
                                <main>
                                    {season?.air_date && <span>{season?.air_date.slice(0, 4)}</span>}
                                    {season?.vote_average && <span><i className='fas fa-star'></i> {season?.vote_average}</span>}
                                </main>
                            </Link>
                        );
                    }
                    return null;
                })}
            </C.Main>
        </C.Container>
    );
};

export default Seasons;
